import { render } from "./VASelect.vue?vue&type=template&id=4a2723ff&ts=true"
import script from "./VASelect.vue?vue&type=script&lang=ts"
export * from "./VASelect.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__